var render, staticRenderFns
import script from "./Parser.vue?vue&type=script&lang=js"
export * from "./Parser.vue?vue&type=script&lang=js"
import style0 from "./Parser.vue?vue&type=style&index=0&id=d6165874&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6165874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6165874')) {
      api.createRecord('d6165874', component.options)
    } else {
      api.reload('d6165874', component.options)
    }
    
  }
}
component.options.__file = "src/components/FormGenerator/components/parser/Parser.vue"
export default component.exports